/* eslint-disable no-use-before-define */
import React from 'react'
import { ajax, Status, parseJson, arrayFrom, isEmpty } from '../../twd/twd'

export const deleteSavedSearches = async (rows) => {
    let deletedIds = arrayFrom(rows)
        .filter(r => r.deleted)
        .map(r => r.id)

    if (isEmpty(deletedIds)) return deletedIds

    let {data} = ajax({
        url: '/esb/portfolio/savedQueryDeleteList',
        method: 'POST',
        params: deletedIds
    })

    let _ = await data

    return deletedIds
}


export const useManageSavedSearches = () => {

    const [status, setStatus] = React.useState(Status.LOADING)
    const [rows, setRows] = React.useState([])

    React.useEffect(() => {
        (async () => {
            if (status!==Status.LOADING) return

            try {
                let {data} = ajax({
                    url: '/esb/portfolio/savedQuerySearchByCurrentUser',
                    method: 'GET'
                })

                let rs = ((await data) || [])
                    .map(a => {
                        a.modified = new Date(a.modified + ' GMT')
                        a.queryText = parseJson(a.formText)
                        a.searchParams = (a.queryText || {}).metadata || a.queryText || {}
                        return a
                    })
                    .filter(a => {
                        return a.searchParams.searchType === 'offers'
                    })
                    .sort((a,b) => b.modified.valueOf() -a.modified.valueOf())

                setRows(rs)
                setStatus(Status.LOADED)
            } catch(e) {
                setStatus(Status.FAILED_TO_LOAD)
            }

        })()
    }, [status])


    return { status, rows, setRows }

}



// WEBPACK FOOTER //
// ./src/saved-searches/manage-saved-searches/use-manage-saved-searches.js